var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g({class:[
    'text-input',
    `text-input--${_vm.color}`,
    { 'text-input--bold': _vm.bold },
    { 'text-input--no-label': !_vm.label },
    { 'text-input--no-margin': _vm.noMargin }
  ],attrs:{"label":_vm.label,"name":_vm.name,"browser-autocomplete":_vm.autocomplete,"value":_vm.value,"error":_vm.error,"rules":_vm.rules,"error-messages":_vm.errorMessages,"prefix":_vm.prefix,"suffix":_vm.suffix,"mask":_vm.mask,"placeholder":_vm.placeholder,"hint":_vm.hint,"type":_vm.type,"validate-on-blur":_vm.validateOnBlur,"pattern":_vm.pattern,"maxlength":_vm.maxlength}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }